'use client';

import { c as _c } from "react/compiler-runtime";
import { ampli } from '@src/ampli-web';
import { useLocale } from '@src/i18n/LocaleProvider';
import { useTrackSelectCta } from '@src/utils/analytics.util';
import { LocalizedLink } from '../LocalizedLink/LocalizedLink';
interface BigFooterColumnProps {
  title: string;
  items: Column[];
}
interface Column {
  text: string;
  href?: string;
  action?: string;
  showOnlyInUS?: boolean;
}
function showOsanoDrawer() {
  if (!window?.Osano) return;
  window.Osano.cm.showDrawer();
}
function LinkOrAction(t0) {
  const $ = _c(9);
  const {
    item
  } = t0;
  const trackSelectCta = useTrackSelectCta();
  if (item.action === "showOsanoDrawer") {
    let t1;
    if ($[0] !== item.text) {
      t1 = <div className="cursor-pointer hover:underline"><a href="" onClick={_temp}>{item.text}</a></div>;
      $[0] = item.text;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const t1 = item.href ?? "";
  let t2;
  if ($[2] !== item.href || $[3] !== trackSelectCta) {
    t2 = () => {
      trackSelectCta({
        "cta url": item.href
      });
      ampli.flush();
    };
    $[2] = item.href;
    $[3] = trackSelectCta;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== item.text || $[6] !== t1 || $[7] !== t2) {
    t3 = <LocalizedLink href={t1} className="hover:underline" onClick={t2}>{item.text}</LocalizedLink>;
    $[5] = item.text;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp(e) {
  e.preventDefault();
  showOsanoDrawer();
}
export const BigFooterColumn = props => {
  const $ = _c(11);
  const {
    items,
    title
  } = props;
  const {
    locale
  } = useLocale();
  const isLocaleUSEnglish = locale.code === "en-US";
  let t0;
  if ($[0] !== title) {
    t0 = <h6 className="mb-3 font-medium">{title}</h6>;
    $[0] = title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== isLocaleUSEnglish || $[3] !== items) {
    t1 = items?.map((item, index) => {
      const {
        showOnlyInUS
      } = item;
      if (showOnlyInUS && !isLocaleUSEnglish) {
        return null;
      }
      return <LinkOrAction item={item} key={`${item.href}-${index}`} />;
    });
    $[2] = isLocaleUSEnglish;
    $[3] = items;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="flex flex-col items-start gap-0.5">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t0 || $[8] !== t2 || $[9] !== title) {
    t3 = <div className="text-body-sm" key={title}>{t0}{t2}</div>;
    $[7] = t0;
    $[8] = t2;
    $[9] = title;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};